let timeout;

function UnSlickAll() {
    let $heroBannerScroll = $('.hero__slider');
    $heroBannerScroll.each(function (key, item) {
        if(this.id === '' || this.id === undefined) {
            var sliderIdName = 'hero__slider' + key;
            this.id = sliderIdName;
            var sliderId = '#' + sliderIdName;
            $(sliderId).slick('unslick');
        }
    });
}

function initCarousel() {
    let $heroBannerScroll = $('.hero__slider');
    $heroBannerScroll.each(function (key, item) {
        if(this.id === '' || this.id === undefined) {
            let sliderIdName = 'hero__slider' + key;
            this.id = sliderIdName;
            var sliderId = '#' + sliderIdName;
            let hiddenInputHeroParent = $(sliderId).closest('.hero');
            let hiddenCarouselCountField = $(hiddenInputHeroParent).find('#multiple-slides-hero-banner-carousel');
            let autoplay = !!($(sliderId).attr('data-auto-play') === 'true' || $(sliderId).attr('data-auto-play') === 'True');
            let $showDots = $(hiddenCarouselCountField).val() === 'true';
            $(sliderId).on('init', function (event, slick) {
                const $carousel = $(this);
                const $dots = $carousel.find('.slick-dots');

                if(!$dots.length) return;
                $dots.attr({
                    role: 'tablist',
                    'aria-label': 'Carousel slides'
                });

                const $buttons = $dots.find('button');
                $buttons.each(function (index) {
                    $(this).attr({
                        role: 'tab',
                        'aria-selected': 'false',
                        'aria-controls': `${$carousel.attr('id')}-slide-${index + 1}`
                    });
                });

                $dots.find('.slick-active button').attr('aria-selected', 'true');

                $carousel.on('click', '.slick-autoplay-toggle-button',
                    function (e) {
                        carouselPlayPauseHandler.call(this, e);
                    }
                );
            }).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: $showDots,
                arrows: false,
                autoplay: autoplay,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                fade: true,
                swipe: true,
                touchMove: true
            });
        }
    });
}

function updateImageWidth() {
    $('.hero__slider-main .hero__container').each(function () {
        if($(this).children().find('.hero__content').length < 1) {
            if($('.hero__slider-main .hero__container').length === 1) {
                $(this).find('.hero__artwork').addClass('hero-empty-single-slide');
            } else {
                $(this).find('.hero__artwork').addClass('hero-full-width');
            }
        }
    });
}

function updateImageHeight() {
    if(window.matchMedia(`(min-width: 72.5rem`).matches) {
        $('.hero__slider .hero__container').each(function () {
            if($(this).children().find('.banner__content').length > 0) {
                heroBannerHeightCalculation($(this));
            }
        });
    }
}

function heroBannerHeightCalculation(elem) {
    var bannerVideo = elem.find('.banner__artwork iframe');
    var bannerImage = elem.find('.banner__artwork img');
    var heroContent = elem.children().find('.banner__content');
    var headingFontSize = elem.children().find('.banner__content h1').css('font-size');
    var paragraphFontSize = elem.children().find('.banner__content p').css('font-size');
    $(elem).find('.banner__artwork').css('height', 'auto');
    let carouselParent = elem.closest('.hero.global-carousel-bg-image');
    if(carouselParent.length) {
        let isNonHomepage = $(carouselParent).data('is-non-homepage') === 'False';
        if(isNonHomepage) {
            return;
        }
    }
    if(bannerVideo.length > 0 && carouselParent.length === 0) {
        if(heroContent.height() >= (bannerVideo.height() - 60)) {
            elem.children().find('.banner__content h1').css({ 'font-size': '2vw' });
            elem.children().find('.banner__content p').css({ 'font-size': '1.3333vw' });
        } else {
            elem.children().find('.banner__content h1').css({ 'font-size': headingFontSize });
            elem.children().find('.banner__content p').css({ 'font-size': paragraphFontSize });
        }
    } else {
        if(heroContent.height() >= (bannerImage.height() - 60)) {
            elem.children().find('.banner__content h1').css({ 'font-size': '2vw' });
            elem.children().find('.banner__content p').css({ 'font-size': '1.3333vw' });
        } else {
            elem.children().find('.banner__content h1').css({ 'font-size': headingFontSize });
            elem.children().find('.banner__content p').css({ 'font-size': paragraphFontSize });
        }
    }
}

function setCarouselDotsHeight() {
    const timer = setTimeout(function () {
        const $sliders = $('.hero__slider');
        $sliders.each(function () {
            const $slider = $(this);
            const $content = $slider.find('.hero__text-container');
            const $dots = $slider.find('.slick-dots');

            if(window.matchMedia('(max-width: 72.499rem)').matches) {
                if($content.length && $dots.length) {
                    const contentTop = $content.position().top;
                    const dotsHeight = $dots.outerHeight(true) || 0;
                    const newTop = contentTop - dotsHeight;
                    $dots.css({ top: `${newTop}px`, bottom: 'auto', position: 'absolute' });
                }
            } else {
                $dots.css({ bottom: '0', top: 'auto' });
            }
        });
        clearTimeout(timer);
    }, 200);
}

function initSlick() {
    UnSlickAll();
    initCarousel();
    updateImageWidth();
    setCarouselDotsHeight();
    if(timeout != null) {
        clearTimeout(timeout);
    }
}

function debounce(func, wait) {
    return function () {
        if(timeout != null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(func, wait);
    };
}

function preserveOriginalColorsOnHover() {
    const $elems = $('.hero.upgraded-banner .hero__link.cta-btn-link');

    $elems.each(function () {
        const $this = $(this);
        const originalBg = $this.css('background-color');
        $this.data('original-bg', originalBg);

        $this.hover(
            function () {
                $(this).css('background-color', $(this).data('original-bg'));
            },
            function () {
                $(this).css('background-color', '');
            }
        );
    });
}

function carouselPlayPauseHandler(e) {
    const $button = $(this);
    const $carousel = $button.closest('.hero__slider');
    const announcer = $('#carousel-status');

    if(!$carousel.hasClass('slick-initialized')) return;

    const isPaused = $button.attr('aria-pressed') === 'true';
    const $pauseText = $button.find('.slick-pause-text');
    const $playText = $button.find('.slick-play-text');

    if(isPaused) {
        $carousel.slick('slickPlay');

        $button.attr({
            'aria-label': 'Pause carousel auto-play',
            'aria-pressed': 'false'
        });

        $pauseText.show().attr('aria-hidden', 'false');

        $playText.hide().attr('aria-hidden', 'true');

        announcer && announcer.text('Carousel playing');
    } else {
        $carousel.slick('slickPause');
        $button.attr({
            'aria-label': 'Play carousel auto-play',
            'aria-pressed': 'true'
        });

        $pauseText.hide().attr('aria-hidden', 'true');

        $playText.show().attr('aria-hidden', 'false');

        announcer && announcer.text('Carousel paused');
    }
}

function carouselKeyboardNavigationHandler(e) {
    const $target = $(e.target);
    const $carousel = $target.closest('.hero__slider');

    if(!$carousel.length) return;
    if(!$carousel.hasClass('slick-initialized')) return;

    let slickCarousel;
    switch (e.key) {
        case 'ArrowRight':
            e.preventDefault();
            $carousel.slick('slickNext');
            $carousel.focus();
            break;

        case 'ArrowLeft':
            e.preventDefault();
            $carousel.slick('slickPrev');
            $carousel.focus();
            break;

        case 'Home':
            e.preventDefault();
            $carousel.slick('slickGoTo', 0);
            $carousel.focus();
            break;

        case 'End':
            e.preventDefault();
            slickCarousel = $carousel.slick('getSlick');
            $carousel.slick('slickGoTo', slickCarousel.slideCount - 1);
            $carousel.focus();
            break;

        default:
    }
}

function applyBackgroundOpacity(opacity = 0.7) {
    $('[class*="bg-opacity"]').each((_, el) => {
        const $el = $(el);
        const computedColor = window.getComputedStyle(el).backgroundColor;
        const rgba = convertToRgba(computedColor, opacity);

        if(rgba) {
            $el.css('background-color', rgba);
        }
    });
}

function convertToRgba(colorStr, newAlpha) {
    const match = colorStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
    if(!match) return null;

    const [, r, g, b] = match;
    return `rgba(${r}, ${g}, ${b}, ${newAlpha})`;
}

$(function () {
    try {
        applyBackgroundOpacity();
        preserveOriginalColorsOnHover();
    } catch (error) {
        console.log('error:', error);
    }
    initCarousel();
    updateImageWidth();
    setCarouselDotsHeight();

    $(window).resize(function () {
        updateImageHeight();
        setCarouselDotsHeight();
        debounce(initSlick, 250);
    });

    $(document).on('keydown', '.hero .hero__slider, .hero .hero__slider *', carouselKeyboardNavigationHandler);
    $('.hero__slider').on('afterChange', function (event, slick, currentSlide) {
        const $carousel = $(this);
        const isFocused = $carousel.is(':focus') || $carousel.find(':focus').length;
        const announcer = document.getElementById('carousel-status');
        if(!announcer || !isFocused) return;

        const $dots = $carousel.find('.slick-dots button');
        if($dots.length) {
            $dots.attr('aria-selected', 'false');
            $carousel.find('.slick-dots .slick-active button').attr('aria-selected', 'true');
        }

        announcer.textContent = '';
        setTimeout(() => {
            announcer.textContent = `Slide ${currentSlide + 1} of ${slick.slideCount}`;
        }, 50);
    });

    $('.hero__slider')
        .on('mouseenter focusin', function () {
            $(this).slick('slickPause');
        })
        .on('mouseleave focusout', function () {
            if(!$(this).is(':hover') && !$(this).find(':focus').length) {
                $(this).slick('slickPlay');
            }
        });

    $('.hero__slider .slick-autoplay-toggle-button').find('span.slick-pause-text').attr('aria-label', 'Pause Carousel autoplay');
    $('.hero__slider .slick-autoplay-toggle-button').find('span.slick-play-text').attr('aria-label', 'Play Carousel autoplay');
});

$(window).on('load', function () {
    updateImageHeight();
});
